import React, { useEffect, useState } from 'react'
import TagCloud from 'TagCloud'
import './index.css'

const WordCloud = () => {
  const [isLoading, setLoad] = useState(true)

  const container = '.content'
  //   ['Java', 'React', 'mongoDB', 'Express', 'NodeJS', 'Redux', 'HTML5', 'CSS3', 'JS', 'Flask', 'Flutter', 'Dart', 'FireBase', 'MySQl','Data Analysis', 'C++', 'C', 'Pythons', 'Machine Learning', 'Git', 'Ubuntu','Artificial Intelligence','Research','Data Preprocessing', ]
  const texts = [
    'Java',
    'Artificial Intelligence',
    'Research',
    'Data Preprocessing',
    'React',
    'mongoDB',
    'Express',
    'NodeJS',
    'Data Analysis',
    'Redux',
    'HTML5',
    'CSS3',
    'JS',
    'FireBase',
    'MySQl',
    'C++',
    'C',
    'Python',
    'Machine Learning',
    'Git',
  ]
  const options = {
    radius: 200,
    // animation speed
    // slow, normal, fast
    maxSpeed: 'fast',
    initSpeed: 'fast',
    // 0 = top
    // 90 = left
    // 135 = right-bottom
    direction: 135,
    // interact with cursor move on mouse out
    keep: true,
  }
  //   to render wordcloud each time the page is reloaded
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (isLoading) {
      TagCloud(container, texts, options)
      console.log('i fire once')
      setLoad(false)
    }
  })

  return (
    <section className='skills__section' >
      <div className="section_counter paralax_mf bg_image">
        <div className="overlay_mf main ">
          <div className="container_1 text ">
            <h2 className='__skills' >My Skills</h2>
            <p className='quote1' >
              I love to keep a variety of tools in my tech stack. I also make sure
              to be pro at using one tool before moving on to the next. I keep
              myself up to date with the latest technologies around.
            </p>
            <p className='quote2' >
              Looking for a role in a company with the opportunity to work with
              the latest technologies on challenging and diverse projects.
            </p>
          </div>
          <div>
            <span className="content"></span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WordCloud
